import React, { useContext, useEffect, useMemo, useState } from "react";
import "./annexureTable.scss";
import {
  getDataColumns,
  getFormattedCellText,
  getValidSerchableKeys,
  shouldDisableEditButtion,
} from "../annexureUtils";
import { IconButton, TextField } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
// import { AnnexureContext } from "../annexureContext";
// import { useAnnexureData, useAuth } from "../../../globalUtils/AuthProvider";
import { useLocation } from "react-router-dom";
import { getParsedLocalStorage } from "../../../../../Utils/storage-utils";
import { APP_BASE_URL_PCDO } from "../../../../../Common/EndPoints";

const TableHeader = ({ data, level }) => {
  const _level = level ?? 0;
  return (
    <tr className="table-header">
      {data.map((field) => {
        const { flex } = field;
        let styles = {
          display: "flex",
          flexDirection: "column",
          justifyContent: "end",
        };
        // if(flex){
        styles["flex"] = flex ?? 1;
        if (_level === 0) {
          styles["minWidth"] = "10em";
        }
        // }
        return (
          <div style={styles} key={field.key}>
            <div className="table-header-cell-text">{field.label}</div>
            {field.childs && (
              <div>
                <TableHeader data={field.childs} level={_level + 1} />
              </div>
            )}
          </div>
        );
      })}
    </tr>
  );
};

const getActionIcon = (
  actionName,
  rowData,
  dataColumns,
  handleActions,
  user,
  annexureInfo
) => {
  if (actionName === "edit_act") {
    return (
      <IconButton
        disabled={shouldDisableEditButtion(user, annexureInfo)}
        onClick={() => {
          handleActions("edit", rowData, dataColumns);
        }}
      >
        <EditIcon />
      </IconButton>
    );
  } else {
    return null;
  }
};
const getCellText = (rowData, colInfo) => {
  const { key, suffix } = colInfo;
  let text = rowData[key] ?? null;
  if (suffix && text) {
    text = `${text} (${suffix})`;
  }
  return text ?? "-";
};

const TableRows = ({ dataColumns, tableData, handleTableActions, agg, annexureInfo }) => {
  // const { annexureList } = useAnnexureData();
  // const { userData } = useAuth();
  const annexureList = getParsedLocalStorage('pcdo_annexure_list')
  const userData = getParsedLocalStorage('pcdo_user_data')
  const location = useLocation();


  const role = userData.role.role;

  const rowMinWidth = dataColumns.reduce((accum, obj) => {
    return accum + (obj?.minWidth ?? 0);
  }, 0);

  const newTableData = useMemo(() => {
    if (agg && tableData?.length > 0 && agg?.type === "sum") {
      let agg_row_key_collection = {};
      const { type, keys } = agg;
      const _data = tableData.map((row) => {
        Object.entries(row).forEach(([key, val]) => {
          if (keys.includes(key)) {
            if (agg_row_key_collection[key]) {
              agg_row_key_collection[key].push(val);
            } else {
              agg_row_key_collection[key] = [val];
            }
          } else {
            agg_row_key_collection[key] = null;
          }
        });
        return {
          row_type: "normal_row",
          ...row,
        };
      });
      const agg_row = { row_type: "agg_row", agg_type: type };

      Object.entries(agg_row_key_collection).forEach(([key, val]) => {
        if (Array.isArray(val)) {
          if (type === "sum") {
            const sum = val.reduce((acc, curr) => {
              const num = Number(curr);
              if (!isNaN(num)) {
                return acc + num;
              } else {
                return acc;
              }
            }, 0);
            agg_row[key] = Number.isInteger(sum) ? sum : sum.toFixed(2);
          }
        } else {
          agg_row[key] = null;
        }
      });
      // agg_row["field"] = "action_col"
      console.log("agg_row", agg_row);
      // const
      return [..._data, agg_row];
      // console.log('agg_row_key_collection',agg_row_key_collection)
    } else {
      return tableData;
    }
  }, [tableData, agg]);

  if (newTableData?.length === 0) {
    return (
      <tbody className="table-body no-data-tbody">
        <div className="no-data-text">No Data Available</div>
      </tbody>
    );
  } else {
    return (
      <tbody className="table-body">
        {newTableData.map((rowData, rowIndex) => {
          return (
            <div
              style={{ minWidth: `${rowMinWidth}em` }}
              className={`table-row ${rowData.row_type ?? ""}`}
            >
              {dataColumns.map((colInfo, colIndex) => {
                if (colInfo.field === "action_col") {
                  if (rowData.row_type === "agg_row") {
                    return (
                      <div
                        style={{ flex: `${colInfo.flex}` }}
                        className="table-cell"
                      >
                        {rowData?.["agg_type"] ?? ""}
                      </div>
                    );
                  } else {
                    return (
                      <div
                        style={{ flex: `${colInfo.flex}` }}
                        className="table-cell"
                      >
                        {colInfo.actionList.map((actionName) => {
                          return getActionIcon(
                            actionName,
                            rowData,
                            dataColumns,
                            handleTableActions,
                            userData,
                            annexureInfo
                          );
                        })}
                      </div>
                    );
                  }
                } else if (colInfo.field === "attachment") {
                  const filePaths = rowData[colInfo?.key] ?? []
                  return <div
                    style={{ flex: `${colInfo.flex}`, cursor: "pointer" }}
                    className="table-cell"
                  >
                    {filePaths.map((filePath) => {
                      const [id, ...rest] = filePath.split('_')
                      const url = `${APP_BASE_URL_PCDO}/annexure/instance/row/attachment/${filePath}`;
                      return <>

                        <a href={url} target="_blank" rel="noreferrer">{rest}</a>
                        <br />
                      </>
                    })}
                  </div>

                } else {
                  const formmattedCellText = getFormattedCellText(
                    colInfo,
                    rowData[colInfo?.key]
                  );
                  return (
                    <div
                      style={{ flex: `${colInfo.flex}`, cursor: "pointer" }}
                      className="table-cell"
                      title={formmattedCellText ?? ""}
                    >
                      {/* {cellText?.length>1? (cellText??"").toString().slice(0,1): (cellText ??'-')} */}
                      {formmattedCellText.length > 90 ? `${formmattedCellText.slice(0, 90)}...` : formmattedCellText}
                      {/* { getCellText(rowData, colInfo)} */}
                    </div>
                  );
                }
              })}
            </div>
          );
        })}
      </tbody>
    );
  }
};

const isValueIncluded = (searchVal, rowObj, validKeys) => {
  const serval = searchVal.toString().toLowerCase();
  for (let key in rowObj) {
    if (validKeys.includes(key)) {
      if (typeof rowObj[key] !== "object") {
        const val = rowObj[key].toString().toLowerCase();
        if (val.includes(serval)) {
          return true;
        }
      }
    }
  }

  return false;
};

function AnneexureTable({
  cols,
  rows,
  isTableLoading,
  handleTableActions,
  annexureInfo,
  agg,
}) {
  const dataColumns = getDataColumns([], cols);

  // console.log('fdsssdgfdghg',rows)
  const [tableCellSearchFilter, setTableSearchCellFIlter] = useState("");
  const formattedData = rows;
  const [filteredData, setFilteredData] = useState(formattedData);

  useEffect(() => {
    let formamatTimeOut = null;
    if (tableCellSearchFilter.length > 0) {
      formamatTimeOut = setTimeout(() => {
        const validKeysToFilter = getValidSerchableKeys(dataColumns);
        const _filteredData = formattedData.filter((rowObj) => {
          return isValueIncluded(
            tableCellSearchFilter,
            rowObj,
            validKeysToFilter
          );
        });
        setFilteredData(_filteredData);
      }, 1000);
    } else {
      setFilteredData(formattedData);
    }

    return () => {
      if (formamatTimeOut) {
        clearTimeout(formamatTimeOut);
      }
    };
  }, [tableCellSearchFilter, formattedData, dataColumns]);

  const handleCellSearchChange = (value) => {
    setTableSearchCellFIlter(value);
  };

  return (
    <div className="annexure-table-container">
      <div className="annexure-table-header">
        <TextField
          size="small"
          label="search"
          value={tableCellSearchFilter}
          onChange={(e) => handleCellSearchChange(e.target.value)}
        />
      </div>
      <div className="annexure-table-container">
        <table>
          <TableHeader data={cols} />
          {isTableLoading ? (
            <div>Loading...</div>
          ) : (
            <TableRows
              agg={agg}
              annexureInfo={annexureInfo}
              dataColumns={dataColumns}
              tableData={filteredData}
              handleTableActions={handleTableActions}
            />
          )}
        </table>
      </div>
      {/* <div className="annexure-table-footer">
        Table Footer - pagination/table tools
      </div> */}
    </div>
  );
}

export default AnneexureTable;
